import React, {useState} from "react";
import data from './data'
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import useSound from "use-sound";
import correct_sound from '../../sound/correct_sound.mp3'
import EmojiIcon from "../EmojiIcon";
import happyman from '../../img/happy-man.png'

import './gameStyle.css'

export default class extends React.Component {
    constructor (props) {
        super(props)
    }


    render() {
        return (
            <div className="content-container">
                <p className="game-intro">
                    Have a go at this drag and drop exercise below. <br />
                    Pick the most helpful and empathic response to the text message you have received from a friend. If you have picked a helpful response, the box will turn green. 
                </p>
                <div>
                    <PromptedCard id={data[0].id} prompt={data[0].prompt} responses={data[0].responses} />
                    <PromptedCard id={data[1].id} prompt={data[1].prompt} responses={data[1].responses} />
                    <PromptedCard id={data[2].id} prompt={data[2].prompt} responses={data[2].responses} />
                </div>
            </div>
        );
    }

}

function PromptedCard(props) {

    const [prompt, setPrompt] = useState(props.prompt);
    const [res, updateRes] = useState(props.responses);
    const [answer, setAnswer] = useState(null);
    const [id, setId] = useState(props.id);

    function handleOnDragEnd(result) {
        if (result.destination) {
            if (result.destination.droppableId === "answer") {
                const items = Array.from(res)
                const [selectedItem] = items.splice(result.source.index, 1);
                console.log(selectedItem)
                updateRes(items)
                setAnswer(selectedItem)
            }

            const items = Array.from(res);
            const [reorderedItem] = items.splice(result.source.index, 1);
            items.splice(result.destination.index, 0, reorderedItem)
            updateRes(items)

        }
        return;
    }

    return (
        <div className="interaction">
            <div id='text-wrapper'>
                <div className="happyman"><EmojiIcon icon={happyman} width="100px"/></div>
                <div className="their-txt">{prompt}</div>
            </div>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                {answerSection()}
                <Droppable droppableId="responses"> 
                    {(provided) => (
                        <ul className="response-section" {...provided.droppableProps} ref={provided.innerRef}>
                        {provided.placeholder}
                        {res.map((res, idx) => {
                            return (
                                <Draggable draggableId={res} index={idx}>
                                    {(provided) => (
                                        <div className="res-card"  {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                            <p className='res-ans'>{res}</p>
                                        </div>
                                    )}
                                </Draggable>
                            )
                        })}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
    )

    function answerSection() {
        const [playSound] = useSound(correct_sound, {volume: 0.5});
        let correctAnswer = false;
        if (answer) {
            if (answer.includes("?") || answer.includes("I'm glad you")) {
                correctAnswer = true;
                playSound();
            }
        }

        let conditions = answer && correctAnswer;
        return <Droppable droppableId="answer">
            { (provided) => (
                <div className={conditions ? "drop-zone correct-answer" : "drop-zone"} {...provided.droppableProps} ref={provided.innerRef}>
                    <div className={conditions ? "res-card" : ""}>
                        <p>{answer}</p>
                    </div>
                </div>
            )}
        </Droppable>;
    }
}


// WEBPACK FOOTER //
// ./src/components/Talk/DndGame.js